import React, { useMemo } from 'react';
import { S5BeforeAfter, S5ImagePair } from '@milanlaser/mlcomponents';
import DefaultBeforeImg from '../../../../images/builder/S5-Placeholder-Before.webp';
import DefaultAfterImg from '../../../../images/builder/S5-Placeholder-After.webp';
import { processBackgroundAndGradientColorMap, processBackgroundColor, useImageKey } from '../../utils/builder.utils';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';

interface ImageSet extends S5ImagePair {
    altBefore?: string;
    altAfter?: string;
}

type S5BeforeAfterBuilderProps = Omit<React.ComponentProps<typeof S5BeforeAfter>, 'imageSet'> & {
    imageSet: ImageSet[];
    backgroundGradient: string;
    desktopPaddingTop?: PaddingSize;
    desktopPaddingBottom?: PaddingSize;
    mobilePaddingTop?: PaddingSize;
    mobilePaddingBottom?: PaddingSize;
};

export function S5BeforeAfterSection(props: S5BeforeAfterBuilderProps) {
    const {
        imageSet: originalImageSet,
        desktopPaddingTop = 'large',
        desktopPaddingBottom = 'large',
        mobilePaddingTop = 'small',
        mobilePaddingBottom = 'small',
        ...otherProps
    } = props;

    const imageSet = originalImageSet?.map((pair) => ({
        before: pair.before || DefaultBeforeImg,
        after: pair.after || DefaultAfterImg,
        altAfter: pair?.altAfter,
        altBefore: pair?.altBefore,
    }));

    const imageSetKey = useMemo(() => useImageKey(imageSet), [imageSet]);

    const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
    const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;

    const modifiedProps = {
        ...otherProps,
        backgroundGradient: processBackgroundColor({
            backgroundGradient: otherProps.backgroundGradient,
        }),
        backgroundColor: processBackgroundColor({
            backgroundColor: otherProps.backgroundColor,
        }),
        className: `mcl-mx-auto mcl-max-w-7xl ${topPaddingClasses} ${bottomPaddingClasses}`,
    };

    //get the background color and gradient color for the wrapper div in builder.
    const backgroundColor = processBackgroundAndGradientColorMap({
        backgroundColor: otherProps.backgroundColor || 'default',
        gradientColor: otherProps.backgroundGradient || 'default',
    });

    return (
        <div className={backgroundColor}>
            <S5BeforeAfter key={imageSetKey} {...modifiedProps} imageSet={imageSet || []} />
        </div>
    );
}
